export default "__VITE_ASSET__B185PeZs__"